import { c as o } from "../../../../index.esm-BeDSGXP5.js";
import { css as t } from "styled-components";
const m = {
  base: () => /* @__PURE__ */ t([
    "",
    " display:block;width:100%;"
  ], o({
    fontSize: [
      "textMediumMobile",
      null,
      "textMediumDesktop"
    ],
    fontWeight: "medium",
    lineHeight: [
      "textMediumMobile",
      null,
      "textMediumDesktop"
    ],
    marginTop: "sm"
  })),
  dark: ({ theme: e }) => /* @__PURE__ */ t([
    "",
    ""
  ], o({
    color: e.componentColors.legend.dark
  })),
  light: ({ theme: e }) => /* @__PURE__ */ t([
    "",
    ""
  ], o({
    color: e.componentColors.legend.light
  }))
};
export {
  m as default
};
